import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Place } from '../Places';
import { AddonAdvertising } from './Addons/advertising';
import type { IAddonAdvertising } from './Addons/advertising.types';
import { AddonMultiCounty } from './Addons/multiCounty';
import type { IAddonMultiCounty } from './Addons/multiCounty.types';
import { AddonPlaceTopSpot } from './Addons/placeTopSpot';
import { IAddonPlaceTopSpot } from './Addons/placeTopSpot.types';
import { AddonTopSpot } from './Addons/topSpot';
import type { IAddonTopSpot } from './Addons/topSpot.types';
import { WriteBatch } from 'firebase/firestore';

type Collections = IAddonAdvertising | IAddonMultiCounty | IAddonTopSpot | IAddonPlaceTopSpot;

@Identifiable
@Timestampable
@Untrackable
export class Addon extends AbstractDocument<Collections> {
  readonly collections = {};
}

export class Addons extends AbstractCollection<Addon, Collections> {
  static path = 'addons';

  constructor(document: Place) {
    super(document.collection(Addons.path), Addon);
  }

  get advertising() {
    return this.getById('advertising');
  }

  get multiCounty() {
    return this.getById('multiCounty');
  }

  get topSpot() {
    return this.getById('topSpot');
  }

  get placeTopSpot() {
    return this.getById('placeTopSpot');
  }

  getById(key: 'advertising'): AddonAdvertising & AddonAdvertising['collections'];
  getById(key: 'multiCounty'): AddonMultiCounty & AddonMultiCounty['collections'];
  getById(key: 'topSpot'): AddonTopSpot & AddonTopSpot['collections'];
  getById(key: 'placeTopSpot'): AddonPlaceTopSpot & AddonPlaceTopSpot['collections'];

  getById(key: Collections['id'], batch?: WriteBatch) {
    let document;

    switch (key) {
      case 'advertising':
        document = new (AbstractCollection as any)(this.reference, AddonAdvertising);
        break;

      case 'multiCounty':
        document = new (AbstractCollection as any)(this.reference, AddonMultiCounty);
        break;

      case 'topSpot':
        document = new (AbstractCollection as any)(this.reference, AddonTopSpot);
        break;
      case 'placeTopSpot':
        document = new (AbstractCollection as any)(this.reference, AddonPlaceTopSpot);
        break;

      default:
        throw new Error('Unknown document ID.');
    }

    return document.getById(key, batch);
  }
}
